import {
  email as emailValidator,
  helpers,
  maxValue as maxValueValidator,
  minValue as minValueValidator,
  required as requiredValidator,
} from '@vuelidate/validators'

export const getValidators = () => {
  const required = helpers.withMessage('base_required_field', requiredValidator)
  const email = helpers.withMessage('base_incorrect_email', emailValidator)
  const minValue = (value = 1) => helpers.withMessage('base_incorrect_data', minValueValidator(value))
  const maxValue = (value = 1000) => helpers.withMessage('base_incorrect_data', maxValueValidator(value))
  const maxArrayLength = (length: number) =>
    helpers.withMessage('base_incorrect_data', (value: unknown[]) => value.length <= length)
  const minArrayLength = (length: number) =>
    helpers.withMessage('base_incorrect_data', (value: unknown[]) => value.length >= length)
  return { required, email, minValue, maxValue, maxArrayLength, minArrayLength }
}
